if (!customElements.get('pupmd-accordion-v2')) {
  class PupmdAccordionV2 extends HTMLElement {
    /** @type {AbortController | null} */
    #abort = null;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      this.querySelectorAll('[data-accordion-panel]').forEach((panelElement) => {
        if (panelElement.getAttribute('aria-hidden') === null) {
          panelElement.setAttribute('aria-hidden', 'true');
        }
      });

      this.querySelectorAll('[data-accordion-trigger]').forEach((triggerButton) => {
        triggerButton.addEventListener('click', () => this.#toggle(triggerButton), { signal });
      });
    }

    disconnectedCallback() {
      this.#abort?.abort();
      this.#abort = null;
    }

    /** @param {Element} accordionItem */
    #closeItem(accordionItem) {
      const triggerButton = accordionItem.querySelector('[data-accordion-trigger]');
      const panelElement = accordionItem.querySelector('[data-accordion-panel]');
      if (!(triggerButton instanceof HTMLElement) || !panelElement) return;

      triggerButton.setAttribute('aria-expanded', 'false');
      accordionItem.classList.remove('is-open');
      panelElement.setAttribute('aria-hidden', 'true');
    }

    /** @param {Element} accordionItem @param {HTMLElement} triggerButton */
    #openItem(accordionItem, triggerButton) {
      const panelElement = accordionItem.querySelector('[data-accordion-panel]');
      if (!panelElement) return;

      triggerButton.setAttribute('aria-expanded', 'true');
      accordionItem.classList.add('is-open');
      panelElement.setAttribute('aria-hidden', 'false');
    }

    /** @param {Element} triggerButton */
    #toggle(triggerButton) {
      const accordionItem = triggerButton.closest('[data-accordion-item]');
      if (!accordionItem || !(triggerButton instanceof HTMLElement)) return;

      const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';

      this.querySelectorAll('[data-accordion-item]').forEach((otherItem) => {
        if (otherItem === accordionItem) return;
        this.#closeItem(otherItem);
      });

      if (isOpen) {
        this.#closeItem(accordionItem);
        return;
      }

      this.#openItem(accordionItem, triggerButton);
    }
  }

  customElements.define('pupmd-accordion-v2', PupmdAccordionV2);
}
